module.exports = __webpack_public_path__ + "static/img/hdlc.d50be2ea.png";